const ACTIVE_STATES = new Set(["ACTIVE", "TRIALING", "PAST_DUE", "UNPAID"]);

export const SUBSCRIPTION_TYPES = [
  "FREE",
  "MONTHLY_SUBSCRIPTION",
  "STARTER",
  "PRO",
  "PRO_PLUS",
];

export function summarizeSubscription(raw) {
  const fallback = {
    type: "FREE",
    status: "ACTIVE",
    isActive: true,
    effectiveType: "FREE",
    displayType: "FREE",
    planFamily: "FREE",
    isFree: true,
    isSmsa: false,
    isPremium: false,
    isMonthlySubscription: false,
    isMonthlySubscriptionRecord: false,
    isStarterRecord: false,
    isProRecord: false,
    isProPlusRecord: false,
    isStarter: false,
    isPro: false,
    isProPlus: false,
    isPendingCheckout: false,
    premiumTier: null,
    stripeCustomerId: null,
    stripeSubscriptionId: null,
    stripeCheckoutSessionId: null,
    currentPeriodEnd: null,
    creditTier: null,
    totalCredits: null,
    creditsUsed: 0,
    addOns: { extraSeats: 0, extraBrands: 0 },
    reportAccess: null,
  };

  if (!raw) {
    return fallback;
  }

  const type = raw.type || "FREE";
  const status = raw.status || "ACTIVE";
  const isActive = ACTIVE_STATES.has(status);
  const planFamily = raw.planFamily || "FREE";

  const isStarterRecord = planFamily === "STARTER" || type === "STARTER";
  const isProRecord     = planFamily === "PRO"     || type === "PRO";
  const isProPlusRecord = planFamily === "PRO_PLUS" || type === "PRO_PLUS";

  const isMonthlySubscriptionRecord =
    planFamily === "MONTHLY_SUBSCRIPTION" ||
    type === "MONTHLY_SUBSCRIPTION" ||
    type === "GENERAL" ||
    isStarterRecord ||
    isProRecord ||
    isProPlusRecord;

  const isPendingCheckout =
    isMonthlySubscriptionRecord &&
    (status === "INCOMPLETE" || status === "INCOMPLETE_EXPIRED");
  // Treat GENERAL as MONTHLY_SUBSCRIPTION for access checks (legacy records
  // created by the old webhook before the planFamily routing was in place)
  const normalizedType = type === "GENERAL" ? "MONTHLY_SUBSCRIPTION" : type;
  const effectiveType = isActive ? normalizedType : "FREE";
  const displayType = isMonthlySubscriptionRecord ? (planFamily !== "FREE" ? planFamily : "MONTHLY_SUBSCRIPTION") : effectiveType;
  const isFree = effectiveType === "FREE";
  const isSmsa = effectiveType === "SMSA";
  const isPremium = effectiveType === "PREMIUM";
  const isMonthlySubscription = isActive && isMonthlySubscriptionRecord;
  const isStarter  = isActive && isStarterRecord;
  const isPro      = isActive && isProRecord;
  const isProPlus  = isActive && isProPlusRecord;
  const premiumTier = isPremium ? raw.premiumTier || null : null;

  return {
    type,
    status,
    isActive,
    effectiveType,
    displayType,
    planFamily,
    isFree,
    isSmsa,
    isPremium,
    isMonthlySubscription,
    isMonthlySubscriptionRecord,
    isStarterRecord,
    isProRecord,
    isProPlusRecord,
    isStarter,
    isPro,
    isProPlus,
    isPendingCheckout,
    premiumTier,
    stripeCustomerId: raw.stripeCustomerId ?? null,
    stripeSubscriptionId: raw.stripeSubscriptionId ?? null,
    stripeCheckoutSessionId: raw.stripeCheckoutSessionId ?? null,
    currentPeriodEnd: raw.currentPeriodEnd ?? null,
    creditTier:   raw.creditTier   ?? null,
    totalCredits: raw.totalCredits ?? null,
    creditsUsed:  raw.creditsUsed  ?? 0,
    addOns: raw.addOns ?? { extraSeats: 0, extraBrands: 0 },
    reportAccess: raw.reportAccess ?? null,
  };
}

export function subscriptionPlanLabel(summary) {
  const s = typeof summary?.effectiveType === "string" ? summary : summarizeSubscription(summary);
  return s.effectiveType;
}

export function subscriptionStatusLabel(summary) {
  const s = summarizeSubscription(summary);
  return s.status;
}
